class PartnerManager {
    constructor() {
        this.opened = false;
        this.openers = document.querySelectorAll('[data-partner-opener]');
        this.modal = document.querySelector('[data-partner-modal]');
        this.form = this.modal.querySelector('[data-partner-form]');
        this.dropdowns = document.querySelectorAll('[data-partner-dropdown]');
        this.body = document.querySelector('body');


        this.csrfParam = document.querySelector('meta[name="csrf-param"]').getAttribute('content');
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

        this.bind();
    }

    bind() {
        this.bindOpeners();
        this.bindForm();
        this.bindDropDowns();
    }

    bindForm() {
        const instance = this;

        if (this.form) {
            this.form.addEventListener('submit', (e) => {
                e.preventDefault();
                instance.handleForm(instance.form)
            });

            const submitButton = this.form.querySelector('button[type="submit"]');
            if (submitButton) {
                submitButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    instance.handleForm(instance.form)
                });
            }
        }
    }

    handleForm(form) {
        const instance = this;
        form.querySelectorAll('input[type="radio"]').forEach((radio) => {
            if (radio.checked) {
                instance.setStore(radio.value)
            }
        });
    }

    bindDropDowns() {
        const instance = this;
        this.dropdowns.forEach((dropdown) => {
            dropdown.addEventListener('change', (e) => {
                instance.setStore(dropdown.value);
            });
        });
    }

    bindOpeners() {
        const instance = this;
        this.openers.forEach((opener) => {
            opener.addEventListener('click', (e) => {
                e.preventDefault();
                instance.opened ? instance.close() : instance.open();
            });
        })
    }

    open() {
        if (this.modal) {
            this.modal.classList.add('_opened');
            this.body.classList.add('_fixed');
            this.opened = true;
        }
    }

    close() {
        if (this.modal) {
            this.modal.classList.remove('_opened');
            this.body.classList.remove('_fixed');
            this.opened = false;
        }
    }

    async setStore(storeId) {
        const response = await this.request(
            '/partner/api/set-store',
            { store_id: storeId },
            'POST',
            true
        )

        if (response.success) {
            location.reload();
        }
    }

    async request(url, data, method, asJson) {
        method = method || 'POST';
        asJson = asJson || true;

        const jax = new Jax(url, method, asJson);

        data[this.csrfParam] = this.csrfToken;

        return  await jax.send(data);
    }
}
function initPartners() {
    new PartnerManager();
}

document.addEventListener('DOMContentLoaded', initPartners);